import { describeFilters } from '..';
import { getSearchQueryMetadata } from '@spa/shared/utils/searchQuery';

export const FILTERS_TO_SEO_TERMS_MAPPING = [
  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSortingByAscendingPrices,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        hasGenderRestrictions
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !hasGenderRestrictions;

      return hasBedroom && isSortingByAscendingPrices && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({ t, language, rentalType: localeTranslations.cheapRoom, detailedLocation, searchQuery });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasEntireProperty,
        isSortingByAscendingPrices,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        hasGenderRestrictions
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !hasGenderRestrictions;

      return hasEntireProperty && isSortingByAscendingPrices && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.cheapApartment,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasStudio,
        isSortingByAscendingPrices,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        hasGenderRestrictions
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !hasGenderRestrictions;

      return hasStudio && isSortingByAscendingPrices && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.cheapStudio,
        detailedLocation,
        searchQuery
      });
    }
  },

  {
    assert: ({ searchQuery }) => {
      const {
        hasEntireProperty,
        isSuitableForStudents,
        rentTypesCount,
        hasStudio,
        hasStudentResidence,
        isSuitableForProfessionals,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudio &&
        !hasStudentResidence &&
        !isSuitableForProfessionals &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasEntireProperty && isSuitableForStudents && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.studentApartment,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasEntireProperty,
        isSuitableForProfessionals,
        rentTypesCount,
        hasStudio,
        hasStudentResidence,
        isSuitableForStudents,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudio &&
        !hasStudentResidence &&
        !isSuitableForStudents &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasEntireProperty && isSuitableForProfessionals && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.professionalApartment,
        detailedLocation,
        searchQuery
      });
    }
  },

  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSuitableForStudents,
        rentTypesCount,
        hasStudentResidence,
        isSuitableForProfessionals,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudentResidence &&
        !isSuitableForProfessionals &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasBedroom && isSuitableForStudents && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.studentRoom,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSuitableForProfessionals,
        rentTypesCount,
        hasStudentResidence,
        isSuitableForStudents,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudentResidence &&
        !isSuitableForStudents &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasBedroom && isSuitableForProfessionals && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.professionalRoom,
        detailedLocation,
        searchQuery
      });
    }
  },

  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSuitableForFemales,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !isSortingByAscendingPrices;

      return hasBedroom && isSuitableForFemales && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.femaleRoom,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSuitableForMales,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !isSortingByAscendingPrices;

      return hasBedroom && isSuitableForMales && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({ t, language, rentalType: localeTranslations.maleRoom, detailedLocation, searchQuery });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSuitableForFemalesOnly,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !isSortingByAscendingPrices;

      return hasBedroom && isSuitableForFemalesOnly && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.femalesOnlyRoom,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasBedroom,
        isSuitableForMalesOnly,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasStudentResidence && !hasOccupationRestrictions && !isSortingByAscendingPrices;

      return hasBedroom && isSuitableForMalesOnly && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.malesOnlyRoom,
        detailedLocation,
        searchQuery
      });
    }
  },

  {
    assert: ({ searchQuery }) => {
      const {
        hasStudio,
        isSuitableForStudents,
        rentTypesCount,
        hasStudentResidence,
        isSuitableForProfessionals,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudentResidence &&
        !isSuitableForProfessionals &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasStudio && isSuitableForStudents && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.studentStudio,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasStudio,
        isSuitableForProfessionals,
        rentTypesCount,
        hasStudentResidence,
        hasGenderRestrictions,
        isSuitableForStudents,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudentResidence &&
        !isSuitableForStudents &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasStudio && isSuitableForProfessionals && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.professionalStudio,
        detailedLocation,
        searchQuery
      });
    }
  },
  {
    assert: ({ searchQuery }) => {
      const {
        hasStudio,
        rentTypesCount,
        hasStudentResidence,
        hasOccupationRestrictions,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 &&
        !hasStudentResidence &&
        !hasOccupationRestrictions &&
        !hasGenderRestrictions &&
        !isSortingByAscendingPrices;

      return hasStudio && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({ t, language, rentalType: localeTranslations.studio, detailedLocation, searchQuery });
    }
  },

  {
    assert: ({ searchQuery }) => {
      const {
        hasStudentResidence,
        hasBedroom,
        rentTypesCount,
        hasOccupationRestrictions,
        hasGenderRestrictions,
        isSortingByAscendingPrices
      } = getSearchQueryMetadata(searchQuery);
      const doesNotConflictWithOtherSEOTitles =
        rentTypesCount === 1 && !hasOccupationRestrictions && !hasGenderRestrictions && !isSortingByAscendingPrices;

      return hasStudentResidence && hasBedroom && doesNotConflictWithOtherSEOTitles;
    },
    buildSEOTitle: ({ t, language, detailedLocation, searchQuery }) => {
      const localeTranslations = RENTAL_TYPE_TRANSLATIONS_MAPPING[language];

      return assembleSEOTerms({
        t,
        language,
        rentalType: localeTranslations.studentResidenceRoom,
        detailedLocation,
        searchQuery
      });
    }
  }
];

export const assembleSEOTerms = ({ t, rentalType, detailedLocation, searchQuery }) => {
  const { featuresAndPetsAllowedText } = describeFilters({ t, searchQuery });

  const filtersDescription = `${rentalType} ${featuresAndPetsAllowedText}`.replace(/\s+/g, ' ').trim();

  return t('{{filtersDescription}} for Rent in {{city}}', {
    filtersDescription,
    city: detailedLocation
  });
};

export const RENTAL_TYPE_TRANSLATIONS_MAPPING = {
  de: {
    studentResidenceRoom: 'Zimmer im Studentenwohnheim',

    studio: 'Studio',
    studentStudio: 'Studentenstudio',
    professionalStudio: 'Studio für Berufstätige',

    studentApartment: 'Wohnung für Studenten',
    professionalApartment: 'Wohnung für Berufstätige',

    studentRoom: 'Zimmer für Studenten',
    professionalRoom: 'Zimmer für Berufstätige',

    femaleRoom: 'Zimmer für Frauen',
    maleRoom: 'Zimmer für Männer',
    femalesOnlyRoom: 'Nur für Frauen Zimmer',
    malesOnlyRoom: 'Nur für Männer Zimmer',

    cheapRoom: 'Günstiges Zimmer',
    cheapApartment: 'Günstige Wohnung',
    cheapStudio: 'Günstiges Studio'
  },
  en: {
    studentResidenceRoom: 'Room in Student Residence',

    studio: 'Studio',
    studentStudio: 'Student Studio',
    professionalStudio: 'Professional Studio',

    studentApartment: 'Student Apartment',
    professionalApartment: 'Professional Apartment',

    studentRoom: 'Student Room',
    professionalRoom: 'Professional Room',

    femaleRoom: 'Female Room',
    maleRoom: 'Male Room',
    femalesOnlyRoom: 'Females Only Room',
    malesOnlyRoom: 'Males Only Room',

    cheapRoom: 'Cheap Room',
    cheapApartment: 'Cheap Apartment',
    cheapStudio: 'Cheap Studio'
  },
  es: {
    studentResidenceRoom: 'Habitación en residencia de estudiantes',

    studio: 'Estudio',
    studentStudio: 'Estudio para estudiantes',
    professionalStudio: 'Estudio para profesional',

    studentApartment: 'Piso para estudiante',
    professionalApartment: 'Piso para profesional',

    studentRoom: 'Habitación para estudiantes',
    professionalRoom: 'Habitación para profesionales',

    femaleRoom: 'Habitación para chicas',
    maleRoom: 'Habitación para chicos',
    femalesOnlyRoom: 'Habitación solo para mujeres',
    malesOnlyRoom: 'Habitación solo para hombres',

    cheapRoom: 'Habitación barata',
    cheapApartment: 'Piso barato',
    cheapStudio: 'Estudio barato'
  },
  fr: {
    studentResidenceRoom: 'Chambre dans résidence étudiante',

    studio: 'Studio',
    studentStudio: 'Studio étudiant',
    professionalStudio: 'Studio professionnel',

    studentApartment: 'Appartement étudiant',
    professionalApartment: 'Appartement pour professionnel',

    studentRoom: 'Chambre étudiant',
    professionalRoom: 'Chambre pour professionnel',

    femaleRoom: 'Chambre pour femme',
    maleRoom: 'Chambre pour homme',
    femalesOnlyRoom: 'Chambre uniquement pour femmes',
    malesOnlyRoom: 'Chambre uniquement pour hommes',

    cheapRoom: 'Chambre pas chère',
    cheapApartment: 'Appartement pas cher',
    cheapStudio: 'Studio pas cher'
  },
  it: {
    studentResidenceRoom: 'Camera in residenza studentesca',

    studio: 'Monolocale',
    studentStudio: 'Monolocale per studenti',
    professionalStudio: 'Monolocale per lavoratori',

    studentApartment: 'Appartamento studenti',
    professionalApartment: 'Appartamento per lavoratori',

    studentRoom: 'Camera in residenza studentesca',
    professionalRoom: 'Stanza per lavoratori',

    femaleRoom: 'Stanza per ragazze',
    maleRoom: 'Stanza per ragazzi',
    femalesOnlyRoom: 'Camera solo per donne',
    malesOnlyRoom: 'Camera solo per uomini',

    cheapRoom: 'Stanza economica',
    cheapApartment: 'Appartamento economico',
    cheapStudio: 'Monolocale economico'
  },
  nl: {
    studentResidenceRoom: 'Kamer in Studentenresidentie',

    studio: 'Studio',
    studentStudio: 'Studentenstudio',
    professionalStudio: 'Professionele Studio',

    studentApartment: 'Studentenappartement',
    professionalApartment: 'Professioneel Appartement',

    studentRoom: 'Studentenkamer',
    professionalRoom: 'Professionele Kamer',

    femaleRoom: 'Vrouwelijke Kamer',
    maleRoom: 'Mannelijke Kamer',
    femalesOnlyRoom: 'Alleen voor Vrouwen Kamer',
    malesOnlyRoom: 'Alleen voor Mannen Kamer',

    cheapRoom: 'Goedkoop Kamer',
    cheapApartment: 'Goedkoop Appartement',
    cheapStudio: 'Goedkoop Studio'
  },
  pl: {
    studentResidenceRoom: 'Pokój w akademiku',

    studio: 'Studio',
    studentStudio: 'Studio studenckie',
    professionalStudio: 'Studio dla profesjonalistów',

    studentApartment: 'Mieszkanie studenckie',
    professionalApartment: 'Mieszkanie dla profesjonalistów',

    studentRoom: 'Pokój studencki',
    professionalRoom: 'Pokój dla profesjonalistów',

    femaleRoom: 'Pokój żeński',
    maleRoom: 'Pokój męski',
    femalesOnlyRoom: 'Pokój tylko dla kobiet',
    malesOnlyRoom: 'Pokój tylko dla mężczyzn',

    cheapRoom: 'Tani pokój',
    cheapApartment: 'Tanie mieszkanie',
    cheapStudio: 'Tanie studio'
  },
  pt: {
    studentResidenceRoom: 'Quarto em residência de estudantes',

    studio: 'Estúdio',
    studentStudio: 'Estúdio de estudante',
    professionalStudio: 'Estúdio para profissional',

    studentApartment: 'Apartamento para estudante',
    professionalApartment: 'Apartamento para profissional',

    studentRoom: 'Quarto para estudante',
    professionalRoom: 'Quarto para profissional',

    femaleRoom: 'Quarto para mulheres',
    maleRoom: 'Quarto para homens',
    femalesOnlyRoom: 'Quarto só para mulheres',
    malesOnlyRoom: 'Quarto só para homens',

    cheapRoom: 'Quarto barato',
    cheapApartment: 'Apartamento barato',
    cheapStudio: 'Estúdio barato'
  },
  zh: {
    studentResidenceRoom: '学生公寓房间',

    studio: '工作室',
    studentStudio: '学生工作室',
    professionalStudio: '专业工作室',

    studentApartment: '学生公寓',
    professionalApartment: '专业公寓',

    studentRoom: '学生房间',
    professionalRoom: '专业房间',

    femaleRoom: '女性专用房间',
    maleRoom: '男性专用房间',
    femalesOnlyRoom: '仅限女性房间',
    malesOnlyRoom: '仅限男性房间',

    cheapRoom: '便宜客房',
    cheapApartment: '便宜公寓',
    cheapStudio: '便宜工作室'
  }
};
